import { render, staticRenderFns } from "./TallerCRMBeneficios.vue?vue&type=template&id=7ed474f4&scoped=true&"
import script from "./TallerCRMBeneficios.vue?vue&type=script&lang=js&"
export * from "./TallerCRMBeneficios.vue?vue&type=script&lang=js&"
import style0 from "./TallerCRMBeneficios.vue?vue&type=style&index=0&id=7ed474f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed474f4",
  null
  
)

export default component.exports